import { useAppContext } from '@src/contexts';
import { FC, PropsWithChildren, ReactElement, Suspense, useEffect } from 'react';

export function LazyFallback(): null {
  const { setGlobalLoading } = useAppContext();

  useEffect(() => {
    setGlobalLoading(true);
    return () => setGlobalLoading(false);
  }, [setGlobalLoading]);

  return null;
}

const LazyLoad: FC<PropsWithChildren> = ({ children }) => <Suspense fallback={<LazyFallback />}>{children}</Suspense>;

// Helper function to wrap an element with LazyLoad
const withLazyLoad = (element: ReactElement): ReactElement => <LazyLoad>{element}</LazyLoad>;

export { withLazyLoad };
